import { Button } from 'components';
import { GithubRepo } from 'gql/graphql';
import { toaster } from 'helpers/toaster';
import { useTranslations } from 'next-intl';
import { useGithubData } from 'providers/IntegrationsProvider/useGithubData';
import { useGithubRepoDestroy } from 'providers/IntegrationsProvider/useGithubRepoDestroy';
import { FC } from 'react';
import { notifyException } from 'services/appsignal';
import { useGithubContext } from '../_context/GithubContext';

interface IDeleteRepository {
  repository: GithubRepo;
}

const DeleteRepository: FC<IDeleteRepository> = ({ repository }) => {
  const { refetch } = useGithubData();
  const { setDeleteId } = useGithubContext();
  const t = useTranslations();
  const { mutateAsync: githubRepoDestroy } = useGithubRepoDestroy({
    onSuccess: () => toaster.success(t('messages.success.deleting_repo')),
    onError: (error: unknown) => {
      notifyException(error);
      toaster.error(t('messages.error.deleting_repo'));
    }
  });

  const handlerRepositoryToDefault = () => setDeleteId('');
  const handlerDestroyRepository = async () => {
    await githubRepoDestroy({ repoId: repository.id });
    handlerRepositoryToDefault();
    refetch();
  };

  return (
    <div className="github__sidebox github__sidebox--added_repository">
      <span className="githhub__sidebox__logo ticon-github"></span>
      <span
        className="github__sidebox__close ticon-cancel"
        onClick={handlerRepositoryToDefault}
      ></span>
      <p>{t('integrations.github.repository')}</p>
      <h3>{repository?.repoName}</h3>
      <p>{t('integrations.github.are_you_sure')}</p>
      <div className="mt-4 flex justify-center">
        <div className="flex gap-4">
          <Button color="danger" onClick={handlerDestroyRepository}>
            {t('integrations.github.remove')}
          </Button>
          <Button color="secondary" onClick={handlerRepositoryToDefault}>
            {t('integrations.github.cancel')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRepository;
